<template>
	<div>
		<h1>
			Simulador de llenado de <br>
		</h1>
		<vs-table search :data="containers" >
			<template slot="header">
				<h1>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
						Contenedor<br>
					</vs-col>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
						<vs-button @click="createContainerPrompt()" radius color="success" type="border" icon="add"></vs-button>
					</vs-col>
					<vs-prompt @cancel="val=''" @accept="createContainer" :active.sync="activePrompt2" title="Crear Contenedor" :is-valid="validName">
						<div class="con-exemple-prompt">
							<!-- <vs-select class="selectExample" label="Cliente" v-model="idClient">
								<vs-select-item size="small" :key="index" :value="item.id" :text="item.client" v-for="(item,index) in clients"/>
							</vs-select> -->
							<vs-select class="selectExample" label="Tipo de Contenedor" v-model="idType">
								<vs-select-item size="small" :key="index" :value="item.id" :text="item.type" v-for="(item,index) in containerType"/>
							</vs-select>
							<vs-input size="small" label="Observación" v-model="observation"/>
							<vs-alert :active="!validName" color="danger" icon="new_releases" class="emptyWarning">
									Completar campos
							</vs-alert>
						</div>
					</vs-prompt>
					
				</h1>
			</template>
			<template slot="thead">
				<!-- <vs-th>
					ID
				</vs-th>
				<vs-th>
					Cliente
				</vs-th> -->
				<vs-th>
					Tipo
				</vs-th>
				<vs-th>
					Total
				</vs-th>
				<vs-th>
					Peso (Kg)
				</vs-th>
				<vs-th>
					Volumen (Mts3)
				</vs-th>
				<vs-th>
					Editar
				</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" :state="data[indextr].actualWeight>data[indextr].containerData.weight ?'danger':data[indextr].actualVolume>data[indextr].containerData.volume ?'danger':null">
					<!-- <vs-td :data="data[indextr].id">
						{{data[indextr].id}}
					</vs-td>

					<vs-td :data="data[indextr].containerData.client">
						{{data[indextr].clientData.client}}
					</vs-td> -->

					<vs-td :data="data[indextr].containerData.type" v-if="data[indextr].status == false">
						{{data[indextr].containerData.type}}
					</vs-td>

					<vs-td :data="data[indextr].totalSale" v-if="data[indextr].status == false">
						L.{{data[indextr].totalSale.toFixed(2)}}
					</vs-td>
					
					<vs-td :data="data[indextr].containerData.weight" v-if="data[indextr].status == false">
						{{data[indextr].actualWeight}}/{{data[indextr].containerData.weight}} ({{data[indextr].percentWeight}}%)
					</vs-td>

					<vs-td :data="data[indextr].containerData.volume" v-if="data[indextr].status == false">
						{{data[indextr].actualVolume}}/{{data[indextr].containerData.volume}} ({{data[indextr].percentVolume}}%)
					</vs-td>

					<vs-td :data="data[indextr].id" v-if="data[indextr].status == false">
						<vs-button  @click="editContainerPrompt(tr, indextr)" vs-type="gradient" size="small" color="success" icon="edit"></vs-button>
						<vs-prompt @cancel="val=''" @accept="editContainer" :active.sync="activePrompt" title="Editar Contenedor">
							<div class="con-exemple-prompt">
								<!-- <vs-select class="selectExample" label="Cliente" v-model="idClient">
									<vs-select-item size="small" :key="index" :value="item.id" :text="item.client" v-for="(item,index) in clients"/>
								</vs-select> -->
								<vs-select class="selectExample" label="Tipo de Contenedor" v-model="idType">
									<vs-select-item size="small" :key="index" :value="item.id" :text="item.type" v-for="(item,index) in containerType"/>
								</vs-select>
								<vs-input size="small" label="Observación" v-model="observation"/>
							</div>
						</vs-prompt>
					</vs-td>
					<template class="expand-user" slot="expand" v-if="data[indextr].status == false">
						<vs-list>
							<vs-table :data=data[indextr].sales>
								<template slot="header">
									<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
										<h3>
											Productos<br>
										</h3>
									</vs-col>
									<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
										
									</vs-col>
								</template>
								<template slot="thead">
									<vs-th>
										Producto
									</vs-th>
									<vs-th>
										Cajas
									</vs-th>
									<vs-th>
										Venta
									</vs-th>
									<vs-th>
										Peso (Kg)
									</vs-th>
									<vs-th>
										Volumen (Mts3)
									</vs-th>
									<vs-th>
										-----
									</vs-th>
								</template>
								<template slot-scope="{data}">
									<vs-tr :key="data[indextr2].id" v-for="(tr, indextr2) in data">
										<vs-td :data="data[indextr2].productData.brand">
											
											<div v-if="data[indextr2].flagCreate==true">
												<!-- <template slot="edit" @change="changeProductData()" > -->
													<!-- <vs-input v-model="data[indextr2].productData.brand" class="inputx" placeholder="Producto"/> -->
													<vs-select class="selectT" v-model="data[indextr2].product" @change="changeProductData(indextr,indextr2)">
														<vs-select-item size="medium"  :key="item.id" :value="item.id" :text="item.brand" v-for="item in products"/>
													</vs-select>
												<!-- </template> -->
											</div>
											<div v-else>
												{{data[indextr2].productData.brand}}	
											</div>
										</vs-td>

										<vs-td :data="data[indextr2].boxes" >
											<div v-if="data[indextr2].flagCreate==true">
												<!-- <template slot="edit"> -->
												<vs-input-number v-model="data[indextr2].boxes" color="success" size="medium" min="1"  @input="changeProductData(indextr,indextr2)">
												</vs-input-number>
											<!-- </template> -->
											</div>
											<div v-else>
												{{data[indextr2].boxes}}
											</div>
										</vs-td>

										<vs-td :data="data[indextr2].productData.subTotalSale">
											<div v-if="data[indextr2].flagCreate==true">
												L.{{data[indextr2].productData.subTotalSale.toFixed(2)}}
												<vs-input-number v-model="data[indextr2].salesPercent" label="%" color="success" size="medium" min="1" @input="changeProductData(indextr,indextr2)" />
											</div>
											<div v-else>
												L.{{data[indextr2].productData.subTotalSale}}
											</div>
										</vs-td>

										
										<vs-td :data="data[indextr2].productData.weight_by_box">
											{{data[indextr2].productData.weight_by_box}}
										</vs-td>

										<vs-td :data="data[indextr2].productData.volumen_by_box">
											{{data[indextr2].productData.volumen_by_box}}
										</vs-td>
										<vs-td>
											<vs-button @click="createSale(indextr,indextr2)" :disabled="data[indextr2].complitedSale == false" v-if="data[indextr2].flagCreate==true" vs-type="gradient" size="small" color="success" icon="done"></vs-button>
											<vs-button @click="removeSale(indextr,indextr2)" vs-type="gradient" size="small" color="danger" icon="delete"></vs-button>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>

							<vs-list-item icon="work" title="Observación" :subtitle="tr.observation"></vs-list-item>
						</vs-list>
						<div class="con-btns-user">
							<div>
								<vs-button @click="openSale(indextr, tr.id)" vs-type="flat" size="medium" color="success"  type="border" icon="add"></vs-button>
							</div>
						</div>
					</template>
				</vs-tr>
			</template>

    </vs-table>
	<!-- <pre>{{ selected }}</pre> -->

	</div>
</template>

<script>
// import {mapState} from 'vuex';

export default {
	data(){
		return{
			containers : [],
			containerType : [],
			// clients: [],
			products: [],
			sales: [],
			val:'Contenedor',
			activePrompt:false,
			activePrompt2:false,
			activeConfirm:false,
			// idContainer: 0,
			type: "",
			// idClient:"",
			idType:"",
			weight: "",
			volume: "",
			observation: "",
			complitedSale: 0,
			trId1: null,
			trId2: null,
			idTr: null,
		}
	},
	computed:{
		validName(){
			return (this.idType.toString().length > 0 && this.observation.length > 0 )
		}
	},
	methods: {
		getContainers(){
			const path = '/containers/'
			this.$http.get(path).then((response) => {
				this.containers = response.data.containersData
				this.containerType = response.data.containerType
				// this.clients = response.data.clientsData
			})
			.catch((error) => {
				console.log(error)
			})
		},
		getProducts(){
			const path = '/products_by_client/'
			this.$http.get(path).then((response) => {
				this.products = response.data.productData
			})
			.catch((error) => {
				console.log(error)
			})
		},
		editContainer(){
			this.containers[this.idTr].type = this.idType;
			var idTypeContainer = this.idType;
			var infoContainer = this.containerType.filter(({id})=>(idTypeContainer == id));
			console.log(this.idTr)
			this.containers[this.idTr].containerData.type = infoContainer[0].type;
			this.containers[this.idTr].containerData.weight = infoContainer[0].weight;
			this.containers[this.idTr].containerData.volume = infoContainer[0].volume;
			this.containers[this.idTr].observation = this.observation;

			var sales = this.containers[this.idTr].sales;
			var sumWeight = 0;
			var sumVolume = 0;
			for (let i of sales) {
				sumWeight += parseFloat(i['productData']['weight_by_box']);
				sumVolume += parseFloat(i['productData']['volumen_by_box']);
			}
			this.containers[this.idTr]['actualVolume'] = sumVolume;
			this.containers[this.idTr]['actualWeight'] = sumWeight;
			var percentVolume = sumVolume*100/this.containers[this.idTr]['containerData']['volume'];
			var percentWeight = sumWeight*100/this.containers[this.idTr]['containerData']['weight'];
			this.containers[this.idTr]['percentVolume'] = percentVolume.toFixed(2);
			this.containers[this.idTr]['percentWeight'] = percentWeight.toFixed(2);
			this.$vs.notify({
				color:'success',
				title:'Cambios realizados exitósamente',
				text:'Simulación de los datos del contenedor'
			})
		},
		createContainer(){
			var idTypeContainer = this.idType;
			var infoContainer = this.containerType.filter(({id})=>(idTypeContainer == id));
			var addContainer = {
				"id": 100,
				"type":this.idType,
				"status":false,
				"observation":this.observation,
				"complitedSale": false,
				"containerData":{
					"type":infoContainer[0].type,
					"weight":infoContainer[0].weight,
					"volume":infoContainer[0].volume,
				},
				"percentVolume": 0.0,
				"percentWeight": 0.0,
				"actualVolume": 0.0,
				"actualWeight": 0.0,
				"totalSale": 0.0,
				"sales":[],
			};
			console.log(addContainer)
			this.containers.unshift(addContainer);
			this.$vs.notify({
				color:'success',
				title:'Cambios realizados exitósamente',
				text:'Creación del contenedor simulado'
			})
		},
		createSale(tr1,tr2){
			this.containers[tr1].sales[tr2].flagCreate = false;
		},
		editContainerPrompt(id, tr){
			this.idTr = tr;
			// this.idContainer = id["id"];
			this.activePrompt = true;
			// this.idClient= id["client"];
			this.idType = id["type"];
			this.observation= id["observation"];
		},
		createContainerPrompt(){
			this.activePrompt2 = true;
			// this.idClient= "";
			this.idType = "";
			this.observation= "";
		},
		openSale(id, container){
			var addSale = {
				"product":null,
				"container":container,
				"boxes":0,
				"salesPercent":10,
				"observation":"",
				"complitedSale": false,
				"flagCreate": true,
				"productData":{
					"brand":"",
					"volumen_by_box":0,
					"weight_by_box":0,
					"price_by_box":100,
					"expiration_date":"",
					"subTotalSale":0,
				}
			};
			this.containers[id].sales.unshift(addSale);
		},
		removeSale(tr1,tr2){
			this.containers[tr1].sales.splice(tr2,1);
			var sales = this.containers[tr1].sales;
			var sumWeight = 0;
			var sumVolume = 0;
			var totalSale = 0;
			for (let i of sales) {
				sumWeight += parseFloat(i['productData']['weight_by_box']);
				sumVolume += parseFloat(i['productData']['volumen_by_box']);
				totalSale += parseFloat(i['productData']['subTotalSale']);
			}
			this.containers[tr1]['actualVolume'] = sumVolume;
			this.containers[tr1]['actualWeight'] = sumWeight;
			this.containers[tr1]['totalSale'] = totalSale;
			var percentVolume = sumVolume*100/this.containers[tr1]['containerData']['volume'];
			var percentWeight = sumWeight*100/this.containers[tr1]['containerData']['weight'];
			this.containers[tr1]['percentVolume'] = percentVolume.toFixed(2);
			this.containers[tr1]['percentWeight'] = percentWeight.toFixed(2);
		},
		changeProductData(tr1, tr2){
			if (this.containers[tr1].sales[tr2]['product'] > 0) {
				var product = this.containers[tr1].sales[tr2]['product'];
				var infoProduct = this.products.filter(({id})=>(product == id));
				this.containers[tr1].sales[tr2]['productData']['brand'] = infoProduct[0]['brand'];
				this.containers[tr1].sales[tr2]['productData']['weight_by_box'] = infoProduct[0]['weight_by_box'] * this.containers[tr1].sales[tr2]['boxes'];
				this.containers[tr1].sales[tr2]['productData']['volumen_by_box'] = infoProduct[0]['volume_by_box'] * this.containers[tr1].sales[tr2]['boxes'];
				this.containers[tr1].sales[tr2]['productData']['subTotalSale'] = Math.round((infoProduct[0]['price_by_box'] * this.containers[tr1].sales[tr2]['boxes'] * (this.containers[tr1].sales[tr2]['salesPercent']/100 + 1))*100)/100;
				var sales = this.containers[tr1].sales;
				var sumWeight = 0;
				var sumVolume = 0;
				var totalSale = 0;
				for (let i of sales) {
					sumWeight += parseFloat(i['productData']['weight_by_box']);
					sumVolume += parseFloat(i['productData']['volumen_by_box']);
					totalSale += parseFloat(i['productData']['subTotalSale']);
				}
				this.containers[tr1]['actualVolume'] = sumVolume;
				this.containers[tr1]['actualWeight'] = sumWeight;
				this.containers[tr1]['totalSale'] = totalSale;
				var percentVolume = sumVolume*100/this.containers[tr1]['containerData']['volume'];
				var percentWeight = sumWeight*100/this.containers[tr1]['containerData']['weight'];
				this.containers[tr1]['percentVolume'] = percentVolume.toFixed(2);
				this.containers[tr1]['percentWeight'] = percentWeight.toFixed(2);
				if (this.containers[tr1].sales[tr2]['boxes'] > 0 && this.containers[tr1].sales[tr2]['salesPercent'] > 0) {
					this.containers[tr1].sales[tr2]['complitedSale'] = true;
				} else {
					this.containers[tr1].sales[tr2]['complitedSale'] = false;	
				}
			}
		}

	},
	created(){
		this.getContainers();
		this.getProducts();
	}
}
</script>

<style lang="stylus">
.con-exemple-prompt
	padding 1px;
	padding-bottom 1px;
	.vs-input
		width 90%
		margin-top 1px;
.emptyWarning{
	width 90%;
	margin-top:10px;
}
.selectT{
	width 100px;
}
.tr-expand td .content-tr-expand, .tr-expand td .tr-expand--close{
	background-color aliceblue;
}
</style>